export const resturantsList = [
  { value: 'Burns Bay Road' },
  { value: 'Downing Street' },
  { value: 'Wall Street' },
  { value: 'Food Junction' },
  { value: 'Drink Yard for All' },
  { value: 'Night Food Junction' }
];

export const locationList = [
  { value: 'Bangalore' },
  { value: 'Chandigarh' },
  { value: 'Delhi' },
  { value: 'Noida' },
  { value: 'Gurgaon' },
  { value: 'Mumbai' }
];
